import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-58a6b35a")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Select Your Label Shape", -1)
const _hoisted_3 = { id: "modal-shapes-container" }
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id", "value", "onInput"]
const _hoisted_6 = ["id", "value", "onInput"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: "close-svg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'shapes-modal-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelShapes, (shape) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "modal-shapes",
              key: shape.id,
              id: shape.id
            }, [
              (shape.id === _ctx.currentLabel.shape_id)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    checked: "",
                    name: "labelShapeInput",
                    type: "radio",
                    id: shape.name,
                    value: shape.name,
                    onInput: ($event: any) => (_ctx.handleInput($event.target, shape.id))
                  }, null, 40, _hoisted_5))
                : (_openBlock(), _createElementBlock("input", {
                    key: 1,
                    name: "labelShapeInput",
                    type: "radio",
                    id: shape.name,
                    value: shape.name,
                    onInput: ($event: any) => (_ctx.handleInput($event.target, shape.id))
                  }, null, 40, _hoisted_6)),
              _createElementVNode("label", {
                for: shape.name,
                class: "label-option"
              }, [
                _createElementVNode("img", {
                  src: require(`@/assets/products/shapes/${shape.id}-a.png`)
                }, null, 8, _hoisted_8),
                _createTextVNode(" " + _toDisplayString(shape.name), 1)
              ], 8, _hoisted_7)
            ], 8, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("button", {
          "aria-label": "Change label shape",
          class: "modal-select-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLabelShapes()))
        }, "Change Label Shape")
      ], 2)
    ], 2)
  ]))
}